"use client";

import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated `@faire/slate/icons/Information` instead */
export const Information = createSVGIcon(
  <>
    <path
      d="M0.857422 12C0.857422 14.9553 2.0314 17.7895 4.12109 19.8792C6.21078 21.9689 9.04501 23.1429 12.0003 23.1429C14.9555 23.1429 17.7898 21.9689 19.8795 19.8792C21.9692 17.7895 23.1431 14.9553 23.1431 12C23.1431 9.04477 21.9692 6.21054 19.8795 4.12085C17.7898 2.03115 14.9555 0.857178 12.0003 0.857178C9.04501 0.857178 6.21078 2.03115 4.12109 4.12085C2.0314 6.21054 0.857422 9.04477 0.857422 12V12Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 12V18"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.1426 7.71432C11.1426 7.94165 11.2329 8.15967 11.3936 8.32041C11.5544 8.48116 11.7724 8.57146 11.9997 8.57146C12.227 8.57146 12.4451 8.48116 12.6058 8.32041C12.7666 8.15967 12.8569 7.94165 12.8569 7.71432C12.8569 7.48699 12.7666 7.26897 12.6058 7.10823C12.4451 6.94748 12.227 6.85718 11.9997 6.85718C11.7724 6.85718 11.5544 6.94748 11.3936 7.10823C11.2329 7.26897 11.1426 7.48699 11.1426 7.71432Z"
      fill="currentColor"
    />
  </>,
  "Information",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    titleAccess: strictLocalize({
      defaultMessage: "Information",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    fill: "none",
  })
);
